import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, normalizeStyle as _normalizeStyle, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, withModifiers as _withModifiers, createTextVNode as _createTextVNode, vModelText as _vModelText, withDirectives as _withDirectives, vModelDynamic as _vModelDynamic, vModelCheckbox as _vModelCheckbox } from "vue"

const _hoisted_1 = { class: "min-h-screen relative overflow-hidden" }
const _hoisted_2 = { class: "relative z-10 min-h-screen flex items-center justify-center" }
const _hoisted_3 = { class: "w-full max-w-4xl" }
const _hoisted_4 = { class: "p-4 lg:p-2" }
const _hoisted_5 = { class: "text-center mb-8" }
const _hoisted_6 = ["src", "alt"]
const _hoisted_7 = { class: "text-center" }
const _hoisted_8 = { class: "text-xl text-white" }
const _hoisted_9 = {
  key: 0,
  class: "mb-6 rounded-md bg-blue-50 p-6"
}
const _hoisted_10 = { class: "flex" }
const _hoisted_11 = { class: "ml-4" }
const _hoisted_12 = { class: "mt-2 text-sm text-blue-800" }
const _hoisted_13 = {
  key: 1,
  class: "mb-6 rounded-md bg-red-50 p-4"
}
const _hoisted_14 = { class: "flex" }
const _hoisted_15 = { class: "ml-3" }
const _hoisted_16 = { class: "text-sm text-red-700" }
const _hoisted_17 = { class: "grid grid-cols-1 md:grid-cols-2 gap-4" }
const _hoisted_18 = { class: "relative" }
const _hoisted_19 = ["type"]
const _hoisted_20 = {
  key: 0,
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 24 24",
  fill: "currentColor",
  class: "w-6 h-6"
}
const _hoisted_21 = {
  key: 1,
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 24 24",
  fill: "currentColor",
  class: "w-6 h-6"
}
const _hoisted_22 = { class: "relative" }
const _hoisted_23 = ["type"]
const _hoisted_24 = {
  key: 0,
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 24 24",
  fill: "currentColor",
  class: "w-6 h-6"
}
const _hoisted_25 = {
  key: 1,
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 24 24",
  fill: "currentColor",
  class: "w-6 h-6"
}
const _hoisted_26 = { class: "flex items-start gap-3 cursor-pointer group" }
const _hoisted_27 = { class: "relative flex-shrink-0 mt-0.5" }
const _hoisted_28 = { class: "text-sm text-white leading-relaxed opacity-90" }
const _hoisted_29 = {
  key: 0,
  class: "mt-3 text-sm text-red-400 flex items-center gap-1"
}
const _hoisted_30 = { class: "flex justify-center" }
const _hoisted_31 = ["disabled"]

import { ref, computed, onMounted } from 'vue'
import { useRoute, useRouter } from 'vue-router'
import { getBrandBySlug } from '@/config/brands'
import api from '@/services/api'


export default /*@__PURE__*/_defineComponent({
  __name: 'SignUpView',
  setup(__props) {

const route = useRoute()
const router = useRouter()

const currentBrand = computed(() => {
  const brandSlug = route.params.brandSlug as string
  return getBrandBySlug(brandSlug)
})

const isFalken = computed(() => currentBrand.value?.name?.toLowerCase() === 'falken')

// eslint-disable-next-line @typescript-eslint/no-var-requires
const backgroundImage = require('@/assets/staticbg.png')

const formData = ref({
  firstName: '',
  lastName: '',
  email: '',
  password: '',
  confirmPassword: ''
})

const loading = ref(false)
const error = ref('')
const showSuccess = ref(false)
const showPassword = ref(false)
const showConfirmPassword = ref(false)
const consentChecked = ref(false)
const consentError = ref(false)

onMounted(() => {
  // Redirect to brand selection if no brand is selected
  if (!currentBrand.value) {
    router.push({ name: 'brand-selection' })
  }
})

const handleSignUp = async () => {
  // Validate consent checkbox first
  if (!consentChecked.value) {
    consentError.value = true
    return
  }
  consentError.value = false

  try {
    loading.value = true
    error.value = ''

    // Validate passwords match
    if (formData.value.password !== formData.value.confirmPassword) {
      throw new Error('Passwords do not match')
    }

    // Validate password length
    if (formData.value.password.length < 8) {
      throw new Error('Password must be at least 8 characters long')
    }

    // Call registration API
    await api.post('/auth/register', {
      brand_id: currentBrand.value?.id,
      first_name: formData.value.firstName,
      last_name: formData.value.lastName,
      email: formData.value.email,
      password: formData.value.password,
      password_confirmation: formData.value.confirmPassword
    })

    const registeredEmail = formData.value.email
    
    showSuccess.value = true

    formData.value = {
      firstName: '',
      lastName: '',
      email: registeredEmail,
      password: '',
      confirmPassword: ''
    }

  } catch (err: any) {
    console.error('Registration error:', err)

    // Handle validation errors from Laravel
    if (err.response?.data?.errors) {
      const errors = err.response.data.errors
      const firstError = Object.values(errors)[0] as string[]
      error.value = firstError[0]
    } else if (err.response?.data?.message) {
      error.value = err.response.data.message
    } else if (err.message) {
      error.value = err.message
    } else {
      error.value = 'Registration failed. Please try again.'
    }
  } finally {
    loading.value = false
  }
}

const goToSignIn = () => {
  router.push({
    name: 'login',
    params: { brandSlug: currentBrand.value?.slug }
  })
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", {
      class: "absolute inset-0 bg-cover bg-center bg-no-repeat",
      style: _normalizeStyle({ backgroundImage: `url(${_unref(backgroundImage)})` })
    }, null, 4),
    _cache[26] || (_cache[26] = _createElementVNode("div", { class: "absolute inset-0 bg-stone-950 bg-opacity-80" }, null, -1)),
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("div", _hoisted_4, [
          _createElementVNode("div", _hoisted_5, [
            (currentBrand.value)
              ? (_openBlock(), _createElementBlock("img", {
                  key: 0,
                  src: currentBrand.value.formLogo,
                  alt: currentBrand.value.name,
                  class: "mx-auto w-120 object-contain"
                }, null, 8, _hoisted_6))
              : _createCommentVNode("", true),
            _createElementVNode("h2", {
              class: "text-6xl font-medium",
              style: _normalizeStyle({ color: currentBrand.value?.color })
            }, _toDisplayString(isFalken.value ? 'Road Hazard Ready' : 'TOTAL CONFIDENCE PLAN'), 5),
            _cache[9] || (_cache[9] = _createElementVNode("p", { class: "mt-6 mb-4 text-2xl text-white" }, " Create an Account ", -1)),
            _createElementVNode("div", _hoisted_7, [
              _createElementVNode("p", _hoisted_8, [
                _cache[8] || (_cache[8] = _createTextVNode(" Already have an account? ")),
                _createElementVNode("a", {
                  href: "#",
                  onClick: _withModifiers(goToSignIn, ["prevent"]),
                  class: "font-medium hover:underline",
                  style: _normalizeStyle({ color: currentBrand.value?.color })
                }, " Sign In ", 4)
              ])
            ])
          ]),
          (showSuccess.value)
            ? (_openBlock(), _createElementBlock("div", _hoisted_9, [
                _createElementVNode("div", _hoisted_10, [
                  _cache[15] || (_cache[15] = _createElementVNode("div", { class: "flex-shrink-0" }, [
                    _createElementVNode("svg", {
                      class: "h-8 w-8 text-blue-400",
                      xmlns: "http://www.w3.org/2000/svg",
                      viewBox: "0 0 24 24",
                      fill: "currentColor"
                    }, [
                      _createElementVNode("path", { d: "M1.5 8.67v8.58a3 3 0 003 3h15a3 3 0 003-3V8.67l-8.928 5.493a3 3 0 01-3.144 0L1.5 8.67z" }),
                      _createElementVNode("path", { d: "M22.5 6.908V6.75a3 3 0 00-3-3h-15a3 3 0 00-3 3v.158l9.714 5.978a1.5 1.5 0 001.572 0L22.5 6.908z" })
                    ])
                  ], -1)),
                  _createElementVNode("div", _hoisted_11, [
                    _cache[12] || (_cache[12] = _createElementVNode("h3", { class: "text-lg font-semibold text-blue-900" }, "Registration Successful!", -1)),
                    _createElementVNode("p", _hoisted_12, [
                      _cache[10] || (_cache[10] = _createTextVNode(" We've sent a verification email to ")),
                      _createElementVNode("strong", null, _toDisplayString(formData.value.email), 1),
                      _cache[11] || (_cache[11] = _createTextVNode(". Please check your inbox and click the verification link to activate your account. "))
                    ]),
                    _cache[13] || (_cache[13] = _createElementVNode("p", { class: "mt-2 text-sm text-blue-700" }, [
                      _createTextVNode(" The link will expire in "),
                      _createElementVNode("strong", null, "48 hours"),
                      _createTextVNode(". ")
                    ], -1)),
                    _cache[14] || (_cache[14] = _createElementVNode("p", { class: "mt-2 text-xs text-blue-600" }, " If you don't see the email, please check your spam folder. ", -1)),
                    _createElementVNode("div", { class: "mt-4" }, [
                      _createElementVNode("button", {
                        onClick: goToSignIn,
                        class: "text-sm font-medium text-blue-700 hover:text-blue-900 underline"
                      }, " Go to Login ")
                    ])
                  ])
                ])
              ]))
            : _createCommentVNode("", true),
          (error.value)
            ? (_openBlock(), _createElementBlock("div", _hoisted_13, [
                _createElementVNode("div", _hoisted_14, [
                  _cache[16] || (_cache[16] = _createElementVNode("div", { class: "flex-shrink-0" }, [
                    _createElementVNode("svg", {
                      class: "h-5 w-5 text-red-400",
                      xmlns: "http://www.w3.org/2000/svg",
                      viewBox: "0 0 20 20",
                      fill: "currentColor"
                    }, [
                      _createElementVNode("path", {
                        "fill-rule": "evenodd",
                        d: "M10 18a8 8 0 100-16 8 8 0 000 16zM8.707 7.293a1 1 0 00-1.414 1.414L8.586 10l-1.293 1.293a1 1 0 101.414 1.414L10 11.414l1.293 1.293a1 1 0 001.414-1.414L11.414 10l1.293-1.293a1 1 0 00-1.414-1.414L10 8.586 8.707 7.293z",
                        "clip-rule": "evenodd"
                      })
                    ])
                  ], -1)),
                  _createElementVNode("div", _hoisted_15, [
                    _createElementVNode("p", _hoisted_16, _toDisplayString(error.value), 1)
                  ])
                ])
              ]))
            : _createCommentVNode("", true),
          (!showSuccess.value)
            ? (_openBlock(), _createElementBlock("form", {
                key: 2,
                onSubmit: _withModifiers(handleSignUp, ["prevent"]),
                class: "space-y-6"
              }, [
                _createElementVNode("div", _hoisted_17, [
                  _createElementVNode("div", null, [
                    _withDirectives(_createElementVNode("input", {
                      id: "firstName",
                      "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((formData.value.firstName) = $event)),
                      type: "text",
                      placeholder: "First Name*",
                      required: "",
                      class: "w-full px-8 py-5 bg-transparent border-2 rounded-lg focus:outline-none placeholder-white placeholder:text-lg brand-input",
                      style: _normalizeStyle({
                    borderColor: currentBrand.value?.color,
                    color: 'white',
                    '--focus-color': currentBrand.value?.color
                  })
                    }, null, 4), [
                      [_vModelText, formData.value.firstName]
                    ])
                  ]),
                  _createElementVNode("div", null, [
                    _withDirectives(_createElementVNode("input", {
                      id: "lastName",
                      "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((formData.value.lastName) = $event)),
                      type: "text",
                      placeholder: "Last Name*",
                      required: "",
                      class: "w-full px-8 py-5 bg-transparent border-2 rounded-lg focus:outline-none placeholder-white placeholder:text-lg brand-input",
                      style: _normalizeStyle({
                    borderColor: currentBrand.value?.color,
                    color: 'white',
                    '--focus-color': currentBrand.value?.color
                  })
                    }, null, 4), [
                      [_vModelText, formData.value.lastName]
                    ])
                  ])
                ]),
                _createElementVNode("div", null, [
                  _withDirectives(_createElementVNode("input", {
                    id: "email",
                    "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((formData.value.email) = $event)),
                    type: "email",
                    placeholder: "Email Address*",
                    required: "",
                    class: "w-full px-8 py-5 bg-transparent border-2 rounded-lg focus:outline-none placeholder-white placeholder:text-lg brand-input",
                    style: _normalizeStyle({
                  borderColor: currentBrand.value?.color,
                  color: 'white',
                  '--focus-color': currentBrand.value?.color
                })
                  }, null, 4), [
                    [_vModelText, formData.value.email]
                  ])
                ]),
                _createElementVNode("div", _hoisted_18, [
                  _withDirectives(_createElementVNode("input", {
                    id: "password",
                    "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((formData.value.password) = $event)),
                    type: showPassword.value ? 'text' : 'password',
                    placeholder: "Password*",
                    required: "",
                    class: "w-full px-8 py-5 pr-14 bg-transparent border-2 rounded-lg focus:outline-none placeholder-white placeholder:text-lg brand-input",
                    style: _normalizeStyle({
                  borderColor: currentBrand.value?.color,
                  color: 'white',
                  '--focus-color': currentBrand.value?.color
                })
                  }, null, 12, _hoisted_19), [
                    [_vModelDynamic, formData.value.password]
                  ]),
                  _createElementVNode("button", {
                    type: "button",
                    onClick: _cache[4] || (_cache[4] = ($event: any) => (showPassword.value = !showPassword.value)),
                    class: "absolute inset-y-0 right-0 pr-4 flex items-center text-white hover:opacity-80 transition-opacity"
                  }, [
                    (showPassword.value)
                      ? (_openBlock(), _createElementBlock("svg", _hoisted_20, _cache[17] || (_cache[17] = [
                          _createElementVNode("path", { d: "M3.53 2.47a.75.75 0 0 0-1.06 1.06l18 18a.75.75 0 1 0 1.06-1.06l-18-18ZM22.676 12.553a11.249 11.249 0 0 1-2.631 4.31l-3.099-3.099a5.25 5.25 0 0 0-6.71-6.71L7.759 4.577a11.217 11.217 0 0 1 4.242-.827c4.97 0 9.185 3.223 10.675 7.69.12.362.12.752 0 1.113Z" }, null, -1),
                          _createElementVNode("path", { d: "M15.75 12c0 .18-.013.357-.037.53l-4.244-4.243A3.75 3.75 0 0 1 15.75 12ZM12.53 15.713l-4.243-4.244a3.75 3.75 0 0 0 4.244 4.243Z" }, null, -1),
                          _createElementVNode("path", { d: "M6.75 12c0-.619.107-1.213.304-1.764l-3.1-3.1a11.25 11.25 0 0 0-2.63 4.31c-.12.362-.12.752 0 1.114 1.489 4.467 5.704 7.69 10.675 7.69 1.5 0 2.933-.294 4.242-.827l-2.477-2.477A5.25 5.25 0 0 1 6.75 12Z" }, null, -1)
                        ])))
                      : (_openBlock(), _createElementBlock("svg", _hoisted_21, _cache[18] || (_cache[18] = [
                          _createElementVNode("path", { d: "M12 15a3 3 0 1 0 0-6 3 3 0 0 0 0 6Z" }, null, -1),
                          _createElementVNode("path", {
                            "fill-rule": "evenodd",
                            d: "M1.323 11.447C2.811 6.976 7.028 3.75 12.001 3.75c4.97 0 9.185 3.223 10.675 7.69.12.362.12.752 0 1.113-1.487 4.471-5.705 7.697-10.677 7.697-4.97 0-9.186-3.223-10.675-7.69a1.762 1.762 0 0 1 0-1.113ZM17.25 12a5.25 5.25 0 1 1-10.5 0 5.25 5.25 0 0 1 10.5 0Z",
                            "clip-rule": "evenodd"
                          }, null, -1)
                        ])))
                  ])
                ]),
                _createElementVNode("div", _hoisted_22, [
                  _withDirectives(_createElementVNode("input", {
                    id: "confirmPassword",
                    "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((formData.value.confirmPassword) = $event)),
                    type: showConfirmPassword.value ? 'text' : 'password',
                    placeholder: "Confirm Password*",
                    required: "",
                    class: "w-full px-8 py-5 pr-14 bg-transparent border-2 rounded-lg focus:outline-none placeholder-white placeholder:text-lg brand-input",
                    style: _normalizeStyle({
                  borderColor: currentBrand.value?.color,
                  color: 'white',
                  '--focus-color': currentBrand.value?.color
                })
                  }, null, 12, _hoisted_23), [
                    [_vModelDynamic, formData.value.confirmPassword]
                  ]),
                  _createElementVNode("button", {
                    type: "button",
                    onClick: _cache[6] || (_cache[6] = ($event: any) => (showConfirmPassword.value = !showConfirmPassword.value)),
                    class: "absolute inset-y-0 right-0 pr-4 flex items-center text-white hover:opacity-80 transition-opacity"
                  }, [
                    (showConfirmPassword.value)
                      ? (_openBlock(), _createElementBlock("svg", _hoisted_24, _cache[19] || (_cache[19] = [
                          _createElementVNode("path", { d: "M3.53 2.47a.75.75 0 0 0-1.06 1.06l18 18a.75.75 0 1 0 1.06-1.06l-18-18ZM22.676 12.553a11.249 11.249 0 0 1-2.631 4.31l-3.099-3.099a5.25 5.25 0 0 0-6.71-6.71L7.759 4.577a11.217 11.217 0 0 1 4.242-.827c4.97 0 9.185 3.223 10.675 7.69.12.362.12.752 0 1.113Z" }, null, -1),
                          _createElementVNode("path", { d: "M15.75 12c0 .18-.013.357-.037.53l-4.244-4.243A3.75 3.75 0 0 1 15.75 12ZM12.53 15.713l-4.243-4.244a3.75 3.75 0 0 0 4.244 4.243Z" }, null, -1),
                          _createElementVNode("path", { d: "M6.75 12c0-.619.107-1.213.304-1.764l-3.1-3.1a11.25 11.25 0 0 0-2.63 4.31c-.12.362-.12.752 0 1.114 1.489 4.467 5.704 7.69 10.675 7.69 1.5 0 2.933-.294 4.242-.827l-2.477-2.477A5.25 5.25 0 0 1 6.75 12Z" }, null, -1)
                        ])))
                      : (_openBlock(), _createElementBlock("svg", _hoisted_25, _cache[20] || (_cache[20] = [
                          _createElementVNode("path", { d: "M12 15a3 3 0 1 0 0-6 3 3 0 0 0 0 6Z" }, null, -1),
                          _createElementVNode("path", {
                            "fill-rule": "evenodd",
                            d: "M1.323 11.447C2.811 6.976 7.028 3.75 12.001 3.75c4.97 0 9.185 3.223 10.675 7.69.12.362.12.752 0 1.113-1.487 4.471-5.705 7.697-10.677 7.697-4.97 0-9.186-3.223-10.675-7.69a1.762 1.762 0 0 1 0-1.113ZM17.25 12a5.25 5.25 0 1 1-10.5 0 5.25 5.25 0 0 1 10.5 0Z",
                            "clip-rule": "evenodd"
                          }, null, -1)
                        ])))
                  ])
                ]),
                _createElementVNode("div", {
                  class: "rounded-lg border-2 p-5",
                  style: _normalizeStyle({ borderColor: currentBrand.value?.color + '66' })
                }, [
                  _createElementVNode("p", {
                    class: "text-sm font-semibold mb-3",
                    style: _normalizeStyle({ color: currentBrand.value?.color })
                  }, " Acknowledgment and Consent ", 4),
                  _createElementVNode("label", _hoisted_26, [
                    _createElementVNode("div", _hoisted_27, [
                      _withDirectives(_createElementVNode("input", {
                        id: "consentCheckbox",
                        "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => ((consentChecked).value = $event)),
                        type: "checkbox",
                        class: "sr-only"
                      }, null, 512), [
                        [_vModelCheckbox, consentChecked.value]
                      ]),
                      _createElementVNode("div", {
                        class: "w-5 h-5 rounded border-2 flex items-center justify-center transition-all duration-200",
                        style: _normalizeStyle({
                      borderColor: currentBrand.value?.color,
                      backgroundColor: consentChecked.value ? currentBrand.value?.color : 'transparent'
                    })
                      }, [
                        (consentChecked.value)
                          ? (_openBlock(), _createElementBlock("svg", {
                              key: 0,
                              xmlns: "http://www.w3.org/2000/svg",
                              viewBox: "0 0 20 20",
                              fill: "currentColor",
                              class: "w-3 h-3",
                              style: _normalizeStyle({ color: currentBrand.value?.buttonTextColor || '#fff' })
                            }, _cache[21] || (_cache[21] = [
                              _createElementVNode("path", {
                                "fill-rule": "evenodd",
                                d: "M16.707 5.293a1 1 0 010 1.414l-8 8a1 1 0 01-1.414 0l-4-4a1 1 0 011.414-1.414L8 12.586l7.293-7.293a1 1 0 011.414 0z",
                                "clip-rule": "evenodd"
                              }, null, -1)
                            ]), 4))
                          : _createCommentVNode("", true)
                      ], 4)
                    ]),
                    _createElementVNode("span", _hoisted_28, [
                      _cache[22] || (_cache[22] = _createTextVNode(" By registering, I confirm that I have read and agree to the ")),
                      _createElementVNode("span", {
                        class: "font-semibold",
                        style: _normalizeStyle({ color: currentBrand.value?.color })
                      }, _toDisplayString(isFalken.value ? 'Road Hazard Ready (RHR)' : 'Continental Total Confidence Plan (TCP)') + " Terms and Conditions ", 5),
                      _cache[23] || (_cache[23] = _createTextVNode(". I consent to the collection, use, processing, and storage of my personal data in accordance with the ")),
                      _createElementVNode("span", {
                        class: "font-semibold",
                        style: _normalizeStyle({ color: currentBrand.value?.color })
                      }, "Data Privacy Act of 2012 (Republic Act No. 10173)", 4),
                      _cache[24] || (_cache[24] = _createTextVNode(" and applicable regulations, for purposes related to warranty registration, verification, claims processing, customer support, and marketing communications. I understand that I may withdraw my consent or opt out of marketing communications at any time. "))
                    ])
                  ]),
                  (consentError.value)
                    ? (_openBlock(), _createElementBlock("p", _hoisted_29, _cache[25] || (_cache[25] = [
                        _createElementVNode("svg", {
                          xmlns: "http://www.w3.org/2000/svg",
                          viewBox: "0 0 20 20",
                          fill: "currentColor",
                          class: "w-4 h-4 flex-shrink-0"
                        }, [
                          _createElementVNode("path", {
                            "fill-rule": "evenodd",
                            d: "M10 18a8 8 0 100-16 8 8 0 000 16zM8.707 7.293a1 1 0 00-1.414 1.414L8.586 10l-1.293 1.293a1 1 0 101.414 1.414L10 11.414l1.293 1.293a1 1 0 001.414-1.414L11.414 10l1.293-1.293a1 1 0 00-1.414-1.414L10 8.586 8.707 7.293z",
                            "clip-rule": "evenodd"
                          })
                        ], -1),
                        _createTextVNode(" You must accept the Terms and Conditions to proceed. ")
                      ])))
                    : _createCommentVNode("", true)
                ], 4),
                _createElementVNode("div", _hoisted_30, [
                  _createElementVNode("button", {
                    type: "submit",
                    disabled: loading.value,
                    class: "px-16 mb-12 py-3 font-medium text-xl rounded-full hover:opacity-90 transition-opacity",
                    style: _normalizeStyle({
                  backgroundColor: currentBrand.value?.buttonColor,
                  color: currentBrand.value?.buttonTextColor,
                  opacity: loading.value ? 0.7 : 1
                })
                  }, _toDisplayString(loading.value ? 'Creating Account...' : 'SIGN UP'), 13, _hoisted_31)
                ])
              ], 32))
            : _createCommentVNode("", true)
        ])
      ])
    ])
  ]))
}
}

})